import {
  Award, BookOpen, Clock, Heart, Leaf, Lock, Mail, ShieldCheck,
  Sparkles, Sprout, Star, Truck, Users, Zap,
} from 'lucide-react';

interface TrustBadgesProps {
  section: any;
}

const ICON_MAP: Record<string, React.ReactNode> = {
  Award: <Award className="h-6 w-6" />,
  BookOpen: <BookOpen className="h-6 w-6" />,
  Clock: <Clock className="h-6 w-6" />,
  Heart: <Heart className="h-6 w-6" />,
  Leaf: <Leaf className="h-6 w-6" />,
  Lock: <Lock className="h-6 w-6" />,
  Mail: <Mail className="h-6 w-6" />,
  ShieldCheck: <ShieldCheck className="h-6 w-6" />,
  Sprout: <Sprout className="h-6 w-6" />,
  Star: <Star className="h-6 w-6" />,
  Truck: <Truck className="h-6 w-6" />,
  Users: <Users className="h-6 w-6" />,
  Zap: <Zap className="h-6 w-6" />,
};

export default function TrustBadges({ section }: TrustBadgesProps) {
  const badges: any[] = section.content?.badges ?? [];
  const headingId = `trust-heading-${section.id}`;

  if (badges.length === 0) return null;

  return (
    <section aria-labelledby={headingId} className="bg-cream border-b border-sage-200">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        {/* Header */}
        {(section.title || section.subtitle) && (
          <div className="text-center mb-12">
            {section.title && (
              <h2
                id={headingId}
                className="font-display text-3xl font-bold text-sage-900 sm:text-4xl"
              >
                {section.title}
              </h2>
            )}
            {section.subtitle && (
              <p className="mt-2 text-sage-600 max-w-xl mx-auto">
                {section.subtitle}
              </p>
            )}
            <div className="mt-4 flex items-center justify-center gap-3" aria-hidden="true">
              <div className="h-px w-12 bg-sage-300" />
              <Sparkles className="h-4 w-4 text-sage-400" />
              <div className="h-px w-12 bg-sage-300" />
            </div>
          </div>
        )}

        {!section.title && (
          <h2 id={headingId} className="sr-only">Trust &amp; Credentials</h2>
        )}

        {/* Badge row */}
        <div className="flex flex-wrap items-start justify-center gap-8 sm:gap-12">
          {badges.map((badge: any, i: number) => (
            <div
              key={i}
              className="flex flex-col items-center text-center max-w-[10rem]"
            >
              <div className="inline-flex items-center justify-center text-sage-600 mb-2" aria-hidden="true">
                {ICON_MAP[badge.icon] ?? <ShieldCheck className="h-6 w-6" />}
              </div>
              <p className="text-sm font-semibold text-sage-900">{badge.label}</p>
              {badge.description && (
                <p className="mt-0.5 text-xs text-sage-500">{badge.description}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
